<script setup lang="ts">
</script>

<template>
  <div class="parent-loader">
    <div class="loader">
    </div>
  </div>
</template>

<style scoped>
</style>